export default __webpack_public_path__ + "static/media/fundserhum.447a6698.png";